import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const paySuccesPromise = import("./PaymentSuccess.js");
export default  Auth(lazy(() => paySuccesPromise));